import React, { useState, useEffect } from 'react';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';
import DataTable from '../../../components/Content/DataTable';
import DateFilterTable from '../../../components/Content/DateFilterTable';

// Date & Time
import moment from 'moment';

// Utils
import { getAlert, getDataWithComp } from '../../../../utils/SamuiUtils';

function Main({ masterList, detailList, statusColours, name, onPageInsert, onRowSelected, getReport }) {
    const [dataMasterList, setDataMasterList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(localStorage.getItem('itemsPerPageDropdown') || 10);
    const [countNewRec, setCountNewRec] = useState(0);
    const [countInStock, setCountInStock] = useState(0);
    const [countCancel, setCountCancel] = useState(0);

    // ใช้สำหรับค้นหาเอกสาร
    const [searchTerm, setSearchTerm] = useState(localStorage.getItem('searchTerm') || '');
    const [filteredItems, setFilteredItems] = useState([]);

    const [startDate, setStartDate] = useState(() => {
        const storedStartDate = localStorage.getItem("startDate");
        return storedStartDate || moment().startOf("month").format("YYYY-MM-DD");
    });
    const [endDate, setEndDate] = useState(() => {
        const storedEndDate = localStorage.getItem("endDate");
        return storedEndDate || moment().endOf("month").format("YYYY-MM-DD");
    });

    const [dateType, setDateType] = useState('1');

    const [selectedStatus, setSelectedStatus] = useState(null);

    const handleStatusClick = (statusName) => {
        if (selectedStatus === statusName) {
            setSelectedStatus(null);
        } else {
            setSelectedStatus(statusName);
        }
    };

    useEffect(() => {
        initialize();
    }, [masterList, detailList]);

    useEffect(() => {
        if (dataMasterList && dataMasterList.length > 0) {
            setCurrentPage(1);
            filterItems();
            localStorage.setItem("searchTerm", searchTerm);
        }
    }, [searchTerm, dataMasterList, selectedStatus]);

    useEffect(() => {
        if (dataMasterList && dataMasterList.length > 0) {
            setCurrentPage(1);
            filterItems();
            localStorage.setItem("startDate", startDate);
            localStorage.setItem("endDate", endDate);
        }
    }, [startDate, endDate, dataMasterList, selectedStatus]);

    const initialize = async () => {
        try {
            if (masterList && masterList.length > 0) {
                setDataMasterList(masterList);

                const image = await getDataWithComp('Upload_File_List', `AND DocCode_ID = 3`);
                const updatedMasterList = masterList.map(item => {
                    return {
                        ...item, File_Name: image
                            .filter(img => img.Doc_ID === item.Rec_ID)
                            .map(img => img.File_Name)
                    };
                });
                setFilteredItems(updatedMasterList);

                // นับข้อมูลสถานะ
                let statusCounts = {
                    'ใบใหม่': 0,
                    'รับเข้าสต๊อคแล้ว': 0,
                    'ยกเลิก': 0
                };

                masterList.forEach(data => {
                    if (data.RecStatus_Name) {
                        statusCounts[data.RecStatus_Name] = (statusCounts[data.RecStatus_Name] || 0) + 1;
                    }
                });

                setCountNewRec(statusCounts['ใบใหม่']);
                setCountInStock(statusCounts['รับเข้าสต๊อคแล้ว']);
                setCountCancel(statusCounts['ยกเลิก']);
                setCurrentPage(1);
            }
        } catch (error) {
            getAlert('FAILED', error.message);
        }
    };

    // filterItems จะกรองข้อมูลตามวันที่และคำค้นหา
    const filterItems = () => {
        try {
            let filtered = masterList;

            // กรองตามวันที่ก่อน
            const start = moment(startDate, "YYYY-MM-DD");
            const end = moment(endDate, "YYYY-MM-DD");

            filtered = filtered.filter(item => {
                const itemDate = dateType === '1'
                    ? moment(item.Rec_Date, "YYYY-MM-DD")
                    : moment(item.Rec_DueDate, "YYYY-MM-DD");
                return itemDate.isBetween(start, end, null, '[]');
            });

            // กรองตาม searchTerm ต่อ
            if (searchTerm.trim() !== '') {
                const lowercasedSearchTerm = searchTerm.toLowerCase();
                filtered = filtered.filter(item =>
                    Object.values(item).some(value => {
                        if (typeof value === 'string') {
                            return value.toLowerCase().includes(lowercasedSearchTerm);
                        } else if (typeof value === 'number') {
                            return value.toString().includes(searchTerm);
                        }
                        return false;
                    })
                );
            }

            // ฟิลเตอร์ตามสถานะที่เลือก
            if (selectedStatus) {
                filtered = filtered.filter((item) => item.RecStatus_Name === selectedStatus);
            }

            setFilteredItems(filtered);
        } catch (error) {
            console.error('Filter error:', error.message);
            setFilteredItems([]);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    // สามารถใช้กรองคำที่จะไม่ใช้ใน Counter Box ได้
    // const filteredStatusColours = statusColours.filter(statusObj =>
    //     !['รออนุมัติ', 'ไม่อนุมัติ'].includes(statusObj.DocSetStaus_Name)
    // );

    return (
        <>
            <div className="page-header d-flex justify-content-between align-items-center mb-0">
                <Breadcrumbs page={name} items={[
                    { name: 'จัดซื้อสินค้า', url: '/purchase' },
                    { name: name, url: '/product-receipt' },
                ]} />
            </div>
            <div className="row" style={{ maxHeight: "85vh", overflowY: "auto" }}>
                <div className="col-1">
                    <center>
                        <b>สถานะเอกสาร</b>
                    </center>
                    <br />
                    {statusColours.map((statusObj, index) => {
                        const { DocSetStaus_Name, DocSetColour } = statusObj;
                        let count;

                        switch (DocSetStaus_Name) {
                            case 'ใบใหม่':
                                count = countNewRec;
                                break;
                            case 'รับเข้าสต๊อคแล้ว':
                                count = countInStock;
                                break;
                            case 'ยกเลิก':
                                count = countCancel;
                                break;
                            default:
                                count = 0;
                        }

                        return (
                            <div
                                key={index}
                                className="col-12 mb-3"
                                onClick={() => handleStatusClick(DocSetStaus_Name)} // เมื่อคลิกสถานะ
                                style={{ cursor: "pointer" }}
                            >
                                <div
                                    className="card text-center"
                                    style={{
                                        backgroundColor: DocSetColour,
                                        boxShadow: selectedStatus === DocSetStaus_Name ? "0 0 15px rgba(0,0,0,0.5)" : "none",
                                        border: selectedStatus === DocSetStaus_Name ? "2px solid #333" : "none",
                                        transform: selectedStatus === DocSetStaus_Name ? "scale(1.05)" : "scale(1)",
                                        transition: "transform 0.15s, box-shadow 0.15s, border 0.15s",
                                    }}
                                >
                                    <div className="card-body d-flex flex-column align-items-center text-white">
                                        <div className="row">
                                            <div className="col-12">
                                                <b style={{ fontSize: "20px", textAlign: "center" }}>
                                                    {count}
                                                </b>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <b style={{ fontSize: "16px", textAlign: "center" }}>
                                                    {DocSetStaus_Name}
                                                </b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="col-11">
                    <div className='p-3 rounded-3 my-2 shadow-lg' style={{ backgroundColor: '#ffff' }}>
                        <div className='row  mb-2'>
                            <div className="col-3">
                                <div className="navbar-form nav-search">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            placeholder="ค้นหาเอกสาร..."
                                            className="form-control"
                                            value={searchTerm}
                                            onChange={(e) => {
                                                setSearchTerm(e.target.value);
                                                localStorage.setItem('searchTerm', e.target.value);
                                            }}
                                        />
                                        <span className="input-group-text">
                                            <i className="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-7 d-flex'>
                                <DateFilterTable
                                    startDate={startDate}
                                    endDate={endDate}
                                    setStartDate={setStartDate}
                                    setEndDate={setEndDate}
                                />
                            </div>
                            <div className="col-2 d-flex justify-content-end">
                                <button
                                    onClick={onPageInsert}
                                    className="btn btn-warning text-white ms-2"
                                    type="button"
                                >
                                    สร้าง{name} <i className="fa fa-plus"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <DataTable
                        currentItems={currentItems}
                        onRowSelected={onRowSelected}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        handlePageChange={handlePageChange}
                        dataMasterList={filteredItems}
                        setDataMasterList={setFilteredItems}
                        itemsPerPage={itemsPerPage}
                        setItemsPerPage={setItemsPerPage}
                        fieldMappings={{
                            no: 'Rec_No',
                            refDoc: 'Ref_Doc',
                            typeName: 'DocType_Name',
                            statusName: 'RecStatus_Name',
                            statusColor: 'RecStatus_Colour',
                            printedStatus: 'Printed_Status',
                            statusPaidName: 'DocStatusPaid_Name',
                            statusPaidColour: 'DocStatusPaid_Colour',
                            date: 'Rec_Date',
                            apCode: 'AP_Code',
                            apName: 'AP_Name',
                            dueDate: 'Rec_DueDate',
                            netTotal: 'NetTotal',
                            createdBy: 'Created_By_Name',
                            updatedBy: 'Update_By_Name',
                            File_Name: "File_Name"
                        }}
                        getReport={(docNo) => {
                            (async () => {
                                try {
                                    await getReport('rec', docNo);
                                } catch (e) {
                                    console.error(e);
                                } finally {
                                    await initialize();
                                }
                            })();
                        }}
                    />
                </div>
            </div>
        </>
    );
}

export default Main;